import React from 'react';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { tokens } from '../../../../public/tokens';
import { CHART_COLORS, CHART_MARGIN, CHART_TEXT_COLOR, ChartBody, ChartFrame, ChartTitle } from '../../../library/Chart';
import { LegendText, PIE_ANGLES } from './Charts.styles';

/**
 * Attendance & Breakdown pie on the class report: students per attendance-percentage band.
 * With no attendance it draws one full "0%" slice whose label and tooltip still show 0.
 * @param {{ type: string, value: number }[]} data One row per band (0-20% ... 80-100%)
 */
export default function AttendanceBreakdownChart({ data }) {
    const hasNoAttendance = data.every((band) => Number(band.value) === 0);
    const slices = hasNoAttendance
        ? [{ type: '0%', value: 0, sliceSize: 1 }]
        : data.map((band) => ({ ...band, sliceSize: Number(band.value) })).filter((band) => Number.isFinite(band.sliceSize));

    return (
        <ChartFrame $height={300}>
            <ChartTitle>Attendance &amp; Breakdown</ChartTitle>
            <ChartBody>
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart margin={CHART_MARGIN}>
                        <Pie
                            data={slices}
                            dataKey="sliceSize"
                            nameKey="type"
                            outerRadius={hasNoAttendance ? '75%' : '100%'}
                            stroke={tokens.colors.neutral.white}
                            strokeWidth={1}
                            {...PIE_ANGLES}
                            labelLine={hasNoAttendance}
                            label={hasNoAttendance && (({ x, y, textAnchor, payload }) => (
                                <text
                                    x={x}
                                    y={y}
                                    textAnchor={textAnchor}
                                    fill={CHART_TEXT_COLOR}
                                    fontSize={tokens.typography.fontSize['md-12px']}
                                >
                                    <tspan x={x}>{payload.type}</tspan>
                                    <tspan x={x} dy="1.2em">{payload.value}</tspan>
                                </text>
                            ))}
                        >
                            {slices.map((slice, index) => (
                                <Cell key={slice.type} fill={CHART_COLORS[index % CHART_COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(sliceSize, band, sliceEntry) => sliceEntry.payload.value} />
                        <Legend
                            layout="vertical"
                            align="right"
                            verticalAlign="middle"
                            iconType="circle"
                            iconSize={8}
                            itemSorter={null}
                            formatter={(band) => <LegendText>{band}</LegendText>}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </ChartBody>
        </ChartFrame>
    );
}
